import { Button } from 'antd';
import apiCall from 'apps/investcore/apiCalls/market-calendar';
import {
  CreatePage,
  DetailPage,
  EditPage,
  ListPage,
} from 'common/ui/AdminCRUD/page';
import { Link } from 'react-router-dom';
import MarketCalendarForm from './form';
import ItemDetail from './detail';
import { columnsGenerator } from './config';

export const MarketCalendarListPage = (props, { params }) => (
  <ListPage
    enableSearch={true}
    title="Market Calendar"
    apiCall={apiCall}
    params={params}
    createUrl={`/admin/market-calendar/create`}
    columnGenerator={props => columnsGenerator(props)}
    resourceName="data"
    {...props}
  />
);

export const MarketCalendarDetailPage = props => (
  <DetailPage
    title="Market Calendar"
    apiCall={apiCall}
    listUrl={`/admin/market-calendar`}
    ItemDetail={ItemDetail}
    resourceName="data"
    extraActions={id => (
      <>
        <Button type="primary">
          <Link to={`/admin/market-calendar/${id}/edit`}>Edit</Link>
        </Button>
      </>
    )}
    {...props}
  />
);

export const MarketCalendarEditPage = props => (
  <EditPage
    title="Market Calendar"
    apiCall={apiCall}
    listUrl={`/admin/market-calendar`}
    ItemForm={MarketCalendarForm}
    options={{ title: 'Edit Market Calendar' }}
    resourceName="data"
    {...props}
  />
);

export const MarketCalendarCreatePage = props => (
  <CreatePage
    title="Market Calendar"
    apiCall={apiCall}
    listUrl={`/admin/market-calendar`}
    ItemForm={MarketCalendarForm}
    resourceName="data"
    {...props}
  />
);
